import Vue from 'vue';
import App from './App';
import router from './router';
import {store} from './store';
import Typograf from 'typograf';
import VueValidate from 'vee-validate';
import {dictionary} from './validate';
import Helpers from './tools/Helpers';
import VueAwesomeSwiper from 'vue-awesome-swiper';

// require styles
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper);

import ShareLink from './tools/share';

import "./assets/scss/app.scss";

Vue.use(VueValidate, {
    locale: 'ru',
    dictionary: {
        en: dictionary.en,
        ru: dictionary.ru
    }
});
let Tp = new Typograf({locale: ['ru', 'en-US']});
Vue.directive('typograph', {
    bind: (el, binding, vnode) => {
        el.innerHTML = Tp.execute(el.innerHTML)
    }
});

Vue.use(ShareLink);


Vue.config.productionTip = false;

new Vue({
    el: '#app',
    store,
    router,
    template: '<App/>',
    data() {
      return {
          Helpers: Helpers,
          isMobile: Helpers.isMobile(),
          gaSend: Helpers.ga().send
      }
    },
    created() {
        window.vue = this;
    },
    components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js